"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineCurrency = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineCurrency = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            return config?.supplier?.currency;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return config?.supplier?.currency;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            return config?.supplier?.currency;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            return config?.supplier?.currency;
        }
        case "CUSTOM": {
            const config = latest_version.config;
            return config?.supplier?.currency;
        }
    }
    return null;
};
exports.getOrderLineCurrency = getOrderLineCurrency;
